import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import {URLSearchParams} from '@angular/http';
import { ExcelServicesService } from '@app/_services/excel-service.service';
import * as XLSX from 'xlsx';



@Component({
  selector: 'app-adminpartner-rekapdata',
  templateUrl: './adminpartner-rekapdata.component.html',
  styleUrls: ['./adminpartner.component.css']
})
export class AdminpartnerRekapdataComponent implements OnInit {

  ListCustomer: any = {};	
  ListServices: any = {};	
  paging: any = {};	
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  limit : number = 100;
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  _STBdata: any = {
    'sn': ''
  };	
  
  table_load = false
  table_data = false

  meta = [];
  self = [];

  Yxlsx:any = [];
  
  
  constructor(public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
   private excelService:ExcelServicesService,
    private router: Router

    ) { }

  ngOnInit() {
    this.loadCustomers();
  }

  refreshPage() {
    this.ngOnInit();
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.name + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isPairing(item: any)
  {
    return (item.services != null);
  }

  loadCustomers() {

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        //console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadcustomer(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadcustomer(this.queryParams);
        }
      });

    //this.table_load = true
    
  }

  loadcustomer(queryParams: any)
  {
    this.table_data = false
    this.table_load = true
    return this.partnerService.GetRekapdata(queryParams).subscribe((output: any) => {
        this.ListCustomer = output.data;
        //this.ListServices = output.data.services;
        
        //console.log(output);
        this.saveToXlsx(this.ListCustomer);

        this.table_load = false
        this.table_data = true
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }

  _STB(item: any){
    // console.log(item);
    if (!item.stbx ) {
      return '-'
    }else{
      return item.stbx
    }
    // this._STBdata = item; 
    // return this._STBdata;
  }

   queryStr(options){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    params.set('limit',this.limit.toString());
    return params.toString();
  }

  dl()
  {
   this.exportAsXLSX();
  }

  saveToXlsx(item){
    let _Yxlsx = [];
    item.forEach((function (value) {
      let x = {SerialNumber:value.sn, Macaddress:value.macaddress, CustomerName:value.CustomerName, PartnerName : value.PartnerName, 
              Service : value.ServiceName,
              StartActiveDate : value.servicestartdate, 
              EndActiveDate : value.serviceenddate, 
              Status: value.CustomerStatus
              };
      _Yxlsx.push(x);
      //console.log(Yxlsx);  
    }));
    this.Yxlsx = _Yxlsx;
    //this._xlsx.push(item);
  }

  filterselect(){
    this.loadcustomer(this.queryParams);
  }

  // filterexport()
  // {
  //   return this.partnerService.Listallcustfilter(this.formFilter.value).subscribe((output: any) => {
  //     this.ListCustexport = output.data;
  //     this.exportAsXLSX()
  //   })
  // }
  exportAsXLSX():void {
    //console.log(this.Yxlsx)
    this.excelService.exportAsExcelFile(this.Yxlsx, 'Report Partner');
  }
}

